import React, { useEffect, useState } from 'react';
import { Link } from 'react-scroll';
import { ArrowRight, Circle } from 'lucide-react';
import HeroSection from '../components/HeroSection';
import ApproachSection from '../components/ApproachSection';
import CapabilitiesSection from '../components/CapabilitiesSection';
import AboutSection from '../components/AboutSection';
import IndustriesSection from '../components/IndustriesSection';
import ReadyToBuildSection from '../components/ReadyToBuildSection';
import LetsWorkSection from '../components/LetsWorkSection';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const Home = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="home-container">
      <Navigation scrolled={scrolled} />
      <HeroSection />
      <ApproachSection />
      <CapabilitiesSection />
      <AboutSection />
      <IndustriesSection />
      <ReadyToBuildSection />
      <LetsWorkSection />
      <Footer />
    </div>
  );
};

export default Home;